import { css } from 'lit';

export const style = css`
  .grid {
    align-items: baseline;
    display: grid;
    flex-grow: 1;
    gap: 1rem;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-top: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .alert {
    margin-top: 0.5em;
  }

  .callout {
    > p {
      margin: 1.5em 0;
    }
  }

  /* stylelint-disable selector-type-no-unknown */
  fs-body-text {
    font-size: 0.75em;
  }

  fs-modal-dialog {
    > p {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;

      > strong {
        font-weight: 700;
        line-height: 24px;
      }
    }
    /* stylelint-enable selector-type-no-unknown */
  }
`;
